import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';
import {ThongBaoComponent} from '../thongbao/thongbao.component';
import {SoanThongBaoComponent} from '../thongbao/create.component';
import {environment} from '../../../../environments/environment';
import {Sessioncommand} from '../../../global/sessioncommand';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoViewComponent} from '../thongbao/thongbaoview.component';
import {NewsService} from '../../../service/info/service-news';
import {SoanTinBaiComponent} from './create.component';
import {NewsComponent} from './news.component';
@Component({
  templateUrl: './viewnews.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ViewNewsComponent implements OnInit, AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef })
  public viewContainerRef: ViewContainerRef;
  public showRef: ComponentRef<Object>;
  public language = language;
  public totalTinBai: number =0;
  public totalThongBao: number =0;
  public totalThongBaoNhap: number =0;
  public status: number[] =[
    environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  constructor( public componentFactoryResolver: ComponentFactoryResolver,
               public newsService: NewsService,
               public thongBaoService: ThongBaoService
  ) {
  }
  ngAfterViewInit() {
    this.loadTotal();
  }
  public showComponent(component)
  {
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const comRef= viewRef.createComponent(factory);
    this.showRef= comRef;
  }
  public loadTotal()
  {
    this.newsService.getCountByKeyword('', -1, Sessioncommand.staffId).subscribe(recordCount => this.totalTinBai = recordCount);
    this.thongBaoService.getCountByKeyword('', Sessioncommand.staffId, -1).subscribe(recordCount => this.totalThongBao = recordCount);
    this.thongBaoService.getCountByKeyword('', -1, Sessioncommand.staffId).subscribe(recordCount => this.totalThongBaoNhap = recordCount);
  }
  public showSoanTinBai() {
    this.showComponent(SoanTinBaiComponent);

  }
  public showTinBai() {
    this.showComponent(NewsComponent);

  }
  public showSoanThongBao() {
    this.showComponent(SoanThongBaoComponent);

  }
  public showDocThongBao() {
    this.showComponent(ThongBaoViewComponent);

  }

  public showThongBao() {
    this.showComponent(ThongBaoComponent);
  }

  ngOnInit(): void {
  }



}

